import { getAgeInYears } from '@/lib/dates';

/** Aadhaar No is required for members older than this age (in years). */
export const AADHAAR_MIN_AGE = 5;

const AADHAAR_LENGTH = 12;

/** Keeps digits only, at most 12. */
export const normalizeAadhaar = (value: string): string =>
  value.replace(/\D/g, '').slice(0, AADHAAR_LENGTH);

/** '482915736104' → '4829 1573 6104'. */
export const formatAadhaar = (value?: string | null): string =>
  value ? normalizeAadhaar(value).replace(/(\d{4})(?=\d)/g, '$1 ') : '';

export const isAadhaarRequired = (dob?: string | null): boolean => {
  const age = getAgeInYears(dob);
  return age !== null && age > AADHAAR_MIN_AGE;
};

/** Returns the error message for an Aadhaar No, or an empty string when it is valid. */
export const getAadhaarError = (value: string | undefined, dob?: string | null): string => {
  const digits = normalizeAadhaar(value ?? '');

  if (!digits) {
    return isAadhaarRequired(dob)
      ? `Please enter Aadhaar No (mandatory above ${AADHAAR_MIN_AGE} years of age)`
      : '';
  }
  if (digits.length !== AADHAAR_LENGTH) return 'Aadhaar No must be 12 digits';
  if (/^[01]/.test(digits)) return 'Enter a valid Aadhaar No';
  return '';
};
